import request from '@/sheep/request';

const FollowApi = {
	// ==================== 关注相关接口 ====================

	// 获取关注列表
	getFollowingPage: (params : { page ?: number; pageSize ?: number }) => {
		return request({
			url: '/wish/attention/following/page',
			method: 'GET',
			data: params,
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},

	// 获取粉丝列表（被关注）
	getFollowerPage: (params : { page ?: number; pageSize ?: number }) => {
		return request({
			url: '/wish/attention/followers/page',
			method: 'GET',
			data: params,
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},

	// 用户关注、取消关注
	attentionUser: async (params : any) => {
		return request({
			url: '/wish/attention/default',
			method: 'GET',
			params: params,
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},
	
	attentionStat: async () => {
		return request({
			url: '/wish/mine/stat',
			method: 'GET',
		});
	},

	// 关注用户
	followUser: (userId : number) => {
		return request({
			url: '/wish/attention/follow',
			method: 'GET',
			params: { userId },
			custom: {
				auth: true,
				showSuccess: true,
				successMsg: '关注成功',
			},
		});
	},

	// 取消关注
	unfollowUser: (userId : number) => {
		return request({
			url: '/wish/attention/unfollow',
			method: 'GET',
			params: { userId },
			custom: {
				auth: true,
				showSuccess: true,
				successMsg: '已取消关注',
			},
		});
	},

	// 检查是否已关注
	checkFollowStatus: (userId : number) => {
		return request({
			url: '/wish/attention/follow/status',
			method: 'GET',
			params: { userId: userId },
			custom: {
				auth: true,
				showLoading: false,
			},
		});
	},

};

export default FollowApi;